import styled from 'styled-components';
import { BLACK } from '../../style';

export const Wrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  transition: transform 150ms ease-in-out;
  padding: 0 ${props => props.margin}px;
`;

export const Background = styled.img`
  display: block;
  max-width:100%;
  max-height:100%;
  opacity: 0.6;
`;

export const SVG = styled.svg`
  position: absolute;
  top: 0;
  left: ${props => props.margin}px;

  text {
    ${'' /* text-anchor: start; */}
    alignment-baseline: middle;
  }

  .smallText {
    font-size: 10px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Plot/Plot.style.js